export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5509.946012c2.jpg";